import { useMutation } from "react-query";
import { confirmWithdrawalFund } from "../services/getWithdrawalFund";

function useWithdrawalFund() {
  return useMutation(["confirm-withdrawal-fund"], confirmWithdrawalFund);
}

export default useWithdrawalFund;
